import { i18nStrings } from 'utils/constants';

const getListValue = (value?: string[]) =>
    value?.length ? value.join(', ') : i18nStrings.emptyValue;

export default getListValue;
